export const fr = {
  translation: {
    Welcome: 'Bienvenue à React et react-i18next',
    Hello: 'Bonjour'
  },
}
